// const apiURL = "http://10.93.30.138:8080/v1";
/* const apiURL = "http://192.168.20.172:8080/citizenapi/v1"; */
const apiURL = "http://192.168.20.172:8080/citizenapi/v1";
/* const apiURL = "https://api.muraciet.az/citizenapi/v1"; */
// const apiURL = "http://10.93.30.124:8082";

export default apiURL;
